import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../baseQuery';

export interface ClassCurriculumPlan {
	id: string;
	curriculumId: string;
	curriculumTitle: string;
	curriculumStatus: string;
	nextModuleIndex: number;
	nextSessionIndex: number;
	nextModuleTitle: string | null;
	nextSessionTitle: string | null;
	status: 'in_progress' | 'paused' | 'completed';
	startedAt: string | null;
	lastAdvancedAt: string | null;
	completedAt: string | null;
	totalSessions: number;
	completedSessions: number;
	progressPct: number;
	periodsTaught: number;
}

export const curriculumPlanApi = createApi({
	reducerPath: 'curriculumPlanApi',
	baseQuery: axiosBaseQuery,
	tagTypes: ['ClassPlans'],
	endpoints: (builder) => ({
		getClassPlans: builder.query<{ plans: ClassCurriculumPlan[] }, string>({
			query: (classId) => ({
				url: `/master-admin/classes/${classId}/curriculum-plans`,
			}),
			providesTags: (_r, _e, classId) => [{ type: 'ClassPlans', id: classId }],
		}),
		updatePlanPointer: builder.mutation<
			any,
			{
				classId: string;
				curriculumId: string;
				moduleIndex: number;
				sessionIndex: number;
			}
		>({
			query: ({ classId, curriculumId, moduleIndex, sessionIndex }) => ({
				url: `/master-admin/classes/${classId}/curriculum-plans/${curriculumId}`,
				method: 'PATCH',
				data: { moduleIndex, sessionIndex },
			}),
			invalidatesTags: (_r, _e, { classId }) => [
				{ type: 'ClassPlans', id: classId },
			],
		}),
	}),
});

export const { useGetClassPlansQuery, useUpdatePlanPointerMutation } =
	curriculumPlanApi;
